export default __webpack_public_path__ + "static/kontordame-be75b8f68dbb2c4b243ac81ed0b4c74f.png";